import { CreateOnlinePaymentResponseDto } from 'entities/payments/model/dtoTypes'
import { CreateOnlinePaymentResponse } from 'entities/payments/model'

export const adaptCreateOnlinePaymentResponseDTO = (
    source: CreateOnlinePaymentResponseDto,
): CreateOnlinePaymentResponse => ({
    paymentUrl: source.payment_url,
    paymentId: source.payment_id,
})
